import { NodoDto } from "@/api";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { useTranslation } from "react-i18next";

export type InfoContaOreProps = {
  nodo: NodoDto;
};

export function InfoContaOre({ nodo }: InfoContaOreProps) {
  const { t } = useTranslation();
  const modelloObj = nodo.dispositivoModello;

  if (!modelloObj) {
    return null;
  }

  const info = nodo.dispositivoLastInfo;
  const contaOreString = info?.contaore ?? t("valori.nd");

  return (
    <>
      {modelloObj.tipoDispositivo === "macchinario" && (
        <Box>
          <Typography variant="caption">{t("infoContaOre.contaOre")}</Typography>
          <Typography variant="h4">{contaOreString}</Typography>
        </Box>
      )}
    </>
  );
}
